import React from "react";


 // const Environment = "PRODUCTION";
 const Environment = "TESTING";
 // const Environment = "DEVELOPMENT";
  //const Environment = "LOCAL";

// const URL =
//   Environment === "PRODUCTION"
//     ? "https://OptiksPro.com"
//     : Environment === "TESTING"
//       ? "https://testing.OptiksPro.com"
//       : Environment === "DEVELOPMENT"
//         ? "https://development.OptiksPro.com"
//         : Environment === "LOCAL"
//           ? "http://localhost:5002"
//           : "";

  const URL =
  Environment === "PRODUCTION"  
    ? "https://optikspro.com"
    : Environment === "TESTING"
    ? "https://testing.optikspro.com"
    : Environment === "DEVELOPMENT"
    ? "https://development.optikspro.com"
    : Environment === "LOCAL"
    ? "http://localhost:6004"
    : "";

// const URL =
//   Environment === "PRODUCTION"
//     ? "https://managepharmacys.com"
//     : Environment === "TESTING"
//     ? "https://testing.managepharmacys.com"
//     : Environment === "DEVELOPMENT"
//     ? "https://development.managepharmacys.com"
//     : Environment === "LOCAL"
//     ? "http://localhost:5002"
//     : "";

export default URL;
